export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const UPDATE_AUTH = 'UPDATE_AUTH';
export const UPDATE_AUTH_TOKEN = 'UPDATE_AUTH_TOKEN';
export const LOADING = 'LOADING';
